import type React from "react";

/**
 * Logo — the Vardic evergreen shield mark (docs/design-system/assets/logo-mark.svg),
 * inlined so it inherits crisp rendering at any size and needs no network fetch.
 * The tile carries its own evergreen background and a white shield-check, so it
 * reads correctly on both the light topbar and the dark sidebar.
 */
export function Logo({
  size = 34,
  className,
}: {
  size?: number;
  className?: string;
}): React.ReactElement {
  return (
    <svg
      aria-hidden="true"
      className={className}
      height={size}
      viewBox="0 0 64 64"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="var(--brand)" height="64" rx="16" width="64" />
      <g
        fill="none"
        stroke="var(--on-brand)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.9"
        transform="translate(13.4 13.4) scale(1.55)"
      >
        <path d="M12 3 5 6v5c0 4.5 3 7.7 7 9 4-1.3 7-4.5 7-9V6l-7-3Z" />
        <path d="m9 12 2 2 4-4" />
      </g>
    </svg>
  );
}
